import React, { useState, useEffect, useContext } from "react";
import "./Personal_Info.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPencil,
  faPencilSquare,
  faPenToSquare,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useForm, Controller } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import classNames from "classnames";
import {
  UserGet,
  UserEdit,
} from "../../../../../utils/apis/myAccount/myAccount";
import { Context } from "../../../../../utils/context";
import { RegxExpression } from "../../../../../utils/common";
import Blue_Btn from "../../../../Common-Component/common_btn/blue_btn/Blue_Btn";
import Green_Btn from "../../../../Common-Component/common_btn/green_btn/Green_Btn";
import Gray_Btn from "../../../../Common-Component/common_btn/gray_btn/Gray_Btn";
import UpdateSuccess from "../../../../Common_modal/UpdateSuccess/UpdateSuccess";
import Success_Modal_2 from "../../../../Common_modal/success_modal2/Success_Modal_2";
// import Green_Btn from '../../common_components/common_btn/green_btn/Green_Btn'
// import Gray_Btn from '../../common_components/common_btn/gray_btn/Gray_Btn'
// import Delete_Contact_Modal from '../../common_components/common_modal/delete_contact_modal/Delete_Contact_Modal'
// import Success_Modal from '../../common_components/common_modal/success_modal/Success_Modal'

const Personal_Info = () => {
  const [editStatus, setEditStatus] = useState(true);
  const navigate = useNavigate();
  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();

  const { shimmerLoader, setShimmerLoader, userdata, setUserData } =
    useContext(Context);
  const [modalShow, setModalShow] = useState(false);
  const onSubmit = async (data) => {
    setShimmerLoader(true);
    const res = await UserEdit(data);
    if (res?.success) {
      setModalShow(true);
      setTimeout(() => {
        setModalShow(false);
        setEditStatus(true);
        setShimmerLoader(false);
      }, 3000);
    } else {
      setShimmerLoader(false);
      if (res?.message?.both) {
        setError("email", { message: res?.message?.both });
        setError("contact_no", { message: "" });
      }
      if (res?.message?.email) {
        setError("email", { message: res?.message?.email });
      }
      if (res?.message?.contact_no) {
        setError("contact_no", { message: res?.message?.contact_no });
      }
    }
  };

  const handleEdit = async () => {
    setEditStatus(!editStatus);
    getUser();
  };

  const getUser = async () => {
    const res = await UserGet();
    if (res?.success) {
      setUserData(res.data);
      reset(res?.data);
    }
  };
  useEffect(() => {
    getUser();
  }, [editStatus]);

  const [isEdit, setIsEdit] = useState(false);
  const [showAlternate, setShowAlternate] = useState(false);
  const [showModal, setShowmodal] = useState(false);

  const getInitials = (name = "") => {
    if (!name) return "";

    const words = name.trim().split(/\s+/);

    if (words.length === 1) {
      return words[0][0].toUpperCase();
    }

    return words[0][0].toUpperCase() + words[words.length - 1][0].toUpperCase();
  };

  return (
    <section className="Personal_Info">
      <div className="top_div">
        <div className="user_img_div">
          {userdata?.first_name ? (
            <div className="name_initials">
              <h1>{getInitials(userdata.first_name)}</h1>
            </div>
          ) : (
            <img src="/assets/Image/my_order/OK.png" className="user_img" />
          )}
        </div>

        {/* <div className="user_img_div">
          <img src="/assets/Image/my_order/OK.png" className="user_img" />
        </div> */}

        {/* <div className="user_img_div">
          <div className="name_initials" ><h1>TG</h1></div>
        </div> */}

        {editStatus && (
          <div className="edit_icon_holder" onClick={handleEdit}>
            <FontAwesomeIcon icon={faPenToSquare} className="edit_icon" />
          </div>
        )}
      </div>

      <div className="personal_info_form">
        <Form>
          <div className="row">
            <div className="col-sm-6">
              <Form.Group
                className="input_group"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Name*</Form.Label>
                <Form.Control
                  disabled={editStatus}
                  type="text"
                  name="first_name"
                  placeholder="Enter First Name"
                  {...register("first_name", {
                    required: "name required",
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.first_name && !editStatus,
                    "is-valid": getValues("first_name") && !editStatus,
                  })}
                  onKeyDown={(event) => {
                    if (!RegxExpression.name.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                />
                {errors?.first_name && (
                  <div className="mt-md-3 mt-sm-3 mt-3">
                    <sup className="text-danger  ">
                      {errors?.first_name?.message}
                    </sup>
                  </div>
                )}
              </Form.Group>
            </div>

            <div className="col-sm-6">
              <Form.Group
                className="input_group"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Email Address*</Form.Label>
                <Form.Control
                  disabled={editStatus}
                  type="text"
                  name="email"
                  placeholder="Enter Email"
                  {...register("email", {
                    required: "Email is required",
                    pattern: {
                      value: RegxExpression.email,
                      message: "Invalid email address",
                    },
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.email && !editStatus,
                    "is-valid": getValues("email") && !editStatus,
                  })}
                />
                {errors?.email && (
                  <div className="mt-md-3 mt-sm-3 mt-3">
                    <sup className="text-danger  ">
                      {errors?.email?.message}
                    </sup>
                  </div>
                )}
              </Form.Group>
            </div>

            <div className="col-sm-6">
              <Form.Group
                className="input_group mobile_group"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Mobile Number*</Form.Label>
                <Form.Control
                  disabled={editStatus}
                  className={classNames("", {
                    "is-invalid": errors?.contact_no && !editStatus,
                    "is-valid": getValues("contact_no") && !editStatus,
                  })}
                  type="text"
                  name="contact_no"
                  placeholder="Enter Mobile Number"
                  {...register("contact_no", {
                    required: "Mobile Number is required",
                    minLength: {
                      value: 10,
                      message: "Number should be at least 10 characters",
                    },
                  })}
                  onKeyDown={(event) => {
                    if (!RegxExpression.phone.test(event.key)) {
                      if (event.key !== "Backspace") {
                        event.preventDefault();
                      }
                    }
                  }}
                  maxLength={10}
                />
                {errors?.contact_no && (
                  <div className="mt-md-3 mt-sm-3 mt-3">
                    <sup className="text-danger  ">
                      {errors?.contact_no?.message}
                    </sup>
                  </div>
                )}

                {showAlternate && (
                  <div className="delete_icon">
                    <FontAwesomeIcon
                      icon={faTrash}
                      className="delete_icon"
                      onClick={() => {
                        setShowmodal(true);
                      }}
                    />
                  </div>
                )}

                {isEdit && (
                  <p
                    className="bottom_text"
                    onClick={() => {
                      setShowAlternate(true);
                    }}
                  >
                    Add Alternative Number
                  </p>
                )}
              </Form.Group>
            </div>

            {/* <div className='col-sm-6'>
                            <Form.Group className='input_group' controlId="exampleForm.ControlInput1">
                                <Form.Label>Date of Birth*</Form.Label>
                                <Form.Control
                                    type="date"
                                    name="name"
                                    {...register("name", {
                                        required: "Name is required",
                                    })}
                                />
                            </Form.Group>
                        </div> */}

            {showAlternate && (
              <div className="col-sm-6">
                <Form.Group
                  className="input_group mobile_group"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Alternate Mobile Number*</Form.Label>
                  <Controller
                    name="contact_no"
                    control={control}
                    rules={{
                      required: "Alternate Mobile Number is required",
                      pattern: {
                        value: /^\+?\d{1,4}[-\s]?\d{10}$/,
                        message:
                          "Invalid number format. Please enter a valid number with an optional country code",
                      },
                    }}
                    render={({ field }) => (
                      <PhoneInput
                        country={"in"}
                        {...field}
                        type="text"
                        placeholder="Enter Mobile Number"
                        maxLength={10}
                      />
                    )}
                  />

                  <div className="delete_icon">
                    <FontAwesomeIcon
                      icon={faTrash}
                      className="delete_icon"
                      onClick={() => {
                        setShowmodal(true);
                      }}
                    />
                  </div>
                </Form.Group>
              </div>
            )}

            {!editStatus && (
              <div className="btns_holder">
                <div className="save_btn">
                  <Green_Btn
                    btn_name="Update"
                    onClick={handleSubmit(onSubmit)}
                  />
                </div>
                <div className="cancel_btn">
                  <Gray_Btn
                    btn_name="Cancel"
                    onClick={() => {
                      {
                        setEditStatus(!editStatus);
                      }
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </Form>
      </div>

      {/* <Delete_Contact_Modal
                modal_title="Delete Contact"
                message="Are you sure, you want to delete this contact?"
                show={showModal}
                onHide={() => { setShowmodal(false) }}
                yesAction={() => { 
                    setShowmodal(false)
                    setShowSucsessModal2(true)
                }}
                noAction={() => { setShowmodal(false) }}
            />



            <Success_Modal
                show={showSuccessModal2}
                onHide={() => { setShowSucsessModal2(false) }}
                successText="Contact Deleted !"
            />


            <Success_Modal
                show={showSuccessModal}
                onHide={() => { setShowSucsessModal(false) }}
                successText="Information Updated !"
            /> */}

      {/* <UpdateSuccess
        show={modalShow}
        onHide={() => setModalShow(false)}
        text={"Data Updated SuccessFully"}
      /> */}

      <Success_Modal_2
        show={modalShow}
        onHide={() => setModalShow(false)}
        successText="Data Updated SuccessFully !"
      />
    </section>
  );
};

export default Personal_Info;
